import React, { useEffect } from 'react'
import { useGetTopCampaignsDetectedReportedRemovedQuery } from '../../redux/Api/AnalyticsApiSlice'
import { Card, CardBody, CardExpandToggler } from '../other/card/card'
import CampaignCard from '../other/card/campaignCard'
import ComponentLoader from '../other/ComponentLoader'
import { toast } from 'react-toastify'

const TopCampaigns = () => {
    const { data: topDetectedReportedRemovedCampaigns, isLoading } = useGetTopCampaignsDetectedReportedRemovedQuery()

    return (
        <div className="col-xl-12 col-lg-6 ">
            <Card className="mb-3 min-h-[382px]">
                <CardBody className="relative p-0">
                    {isLoading ? <ComponentLoader /> : null}
                    <div className='p-4'>
                        <div className="d-flex fw-bold small mb-3">
                            <span className="flex-grow-1">Top Campaings</span>
                            <CardExpandToggler />
                        </div>
                        <div className='flex gap-4 flex-wrap justify-center'>
                            {topDetectedReportedRemovedCampaigns?.current_year?.map((item) => (
                                <CampaignCard type={"top"} item={item} key={item.campaign_name}/>
                            ))}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>

    )
}

export default TopCampaigns